let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwr6m")).then(() => parcelRequire('3EQqZ'));